export default {"src":"/_next/static/media/privacy.fd5137c1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};